import PropTypes from "prop-types";
import React from "react";

import { Button } from "../Button";
import { Image } from "../Image";

import "./styles.scss";

export const BrowseButton = ({ disabled, onClick, ...props }) => (
  <Button
    className="apti-BrowseButton"
    disabled={disabled}
    name="browse-button"
    onClick={onClick}
    type="button"
    {...props}
  >
    <>
      <Image alt="folder" src="icons/folder.svg" />
      Browse
    </>
  </Button>
);

BrowseButton.propTypes = {
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

BrowseButton.defaultProps = {
  disabled: false,
  onClick: () => {},
};
